import React from 'react'
import apiService from 'services/api'
import { filterStoreRepo } from '../../../../Filters/FilterStore'
import FilterModal from '../../../../Filters/components/FilterModal'
import { FilterIdentifier } from 'models/saved_view'
import { CommonFiltersetDoorsAccountGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetDoorsAccountGroup'
import { CommonFiltersetGooglePlaceDoorGroup } from '../../GooglePlaceBase/GooglePlaceDoorBaseTable/CommonFiltersetGooglePlaceDoorGroup'
import { LODGING_DOORS_COLUMNS } from '../LodgingDoorsColumnsInfo'

export function LodgingDoorsFilterset({
  filterIdentifier,
  hideCampaignsFilter,
}: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const api = apiService()
  const { data: campaignOptions } = api.useGetCampaignsOptions(
    'lodging-hospitality'
  )

  const lodgingFilterStore = filterStoreRepo.getStore(filterIdentifier)
  const { data: lodgingCityStates } = api.useCommonGetCityStates(
    'lodging-hospitality'
  )

  return (
    <FilterModal identifier={filterIdentifier} store={lodgingFilterStore}>
      <CommonFiltersetDoorsAccountGroup
        filterStore={lodgingFilterStore}
        campaignOptions={campaignOptions}
        hideCampaignsFilter={hideCampaignsFilter}
      />
      <CommonFiltersetGooglePlaceDoorGroup
        filterStore={lodgingFilterStore}
        columns={LODGING_DOORS_COLUMNS}
        allAvailableCities={lodgingCityStates}
      />
    </FilterModal>
  )
}
